import React from 'react'
import afterpayHeader from '../../assets/afterpay-header.jpg'

const AfterpayBanner = () => (
  <div style={{ display: 'flex', justifyContent: 'center', background: '#000', padding: '2px 12px' }}>
    <img src={afterpayHeader} style={{ width: '100%', maxWidth: '400px' }} alt="Now offering Afterpay!" />
  </div>
)

export default AfterpayBanner
